import type { App } from 'vue';

import PrimeVue from 'primevue/config';
import Lara from '@primeuix/themes/lara';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import StyleClass from 'primevue/styleclass';

import { definePreset, palette, type ColorScale } from '@primeuix/themes';

const CustomPreset = definePreset(Lara, {
  semantic: {
    primary: {
      200: '#01baef',
      ...(palette('#0B4F6C') as ColorScale),
    },
    surface: {
      0: '#ffffff',
      50: '#FAFAFA',
      100: '#F4F4F5',
      200: '#E4E4E7',
      300: '#D4D4D8',
      400: '#A1A1AA',
      500: '#71717A',
      600: '#52525B',
      700: '#3F3F46',
      800: '#27272A',
      900: '#18181B',
    },
    colorScheme: {
      light: {
        focusRing: {
          shadow: '0 0 0 0.2rem rgb(11 79 108 / 30%)',
        },
        formField: {
          focusBorderColor: '{primary.500}',
        },
      },
    },
  },
  components: {
    accordion: {
      colorScheme: {
        light: {
          header: {
            background: '{primary.500}',
            color: '{surface.0}',
            hoverBackground: '{primary.500}',
            activeHoverBackground: '{primary.500}',
            hoverColor: '{surface.0}',
            activeColor: '{surface.0}',
            activeHoverColor: '{surface.0}',
            activeBackground: '{primary.500}',

            borderColor: '{primary.500}',

            toggleIcon: {
              color: '{surface.0}',
              hoverColor: '{surface.0}',
              activeColor: '{surface.0}',
              activeHoverColor: '{surface.0}',
            },
          },
          content: {
            borderColor: '{primary.200}',
          },
        },
      },
    },
    drawer: {
      content: {
        padding: '0',
      },
    },
    panel: {
      root: {
        borderColor: '{primary.500}',
      },
      colorScheme: {
        light: {
          header: {
            borderWidth: '0',
            background: '{primary.500}',
            color: '{surface.0}',
          },
        },
      },
    },
  },
});

export default (app: App) => {
  app.use(PrimeVue, {
    theme: {
      preset: CustomPreset,
      options: {
        darkModeSelector: false,
      },
    },
    locale: {
      accept: 'Si',
      reject: 'No',
      //...
    },
    pt: {
      panel: {
        root: {
          class: 'overflow-hidden',
        },
      },
    },
  });

  app.use(ConfirmationService);
  app.use(DialogService);
  app.directive('styleclass', StyleClass);
};
